import { render, staticRenderFns } from "./connom_tab.vue?vue&type=template&id=febe5e50&scoped=true&"
import script from "./connom_tab.vue?vue&type=script&lang=js&"
export * from "./connom_tab.vue?vue&type=script&lang=js&"
import style0 from "./connom_tab.vue?vue&type=style&index=0&id=febe5e50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "febe5e50",
  null
  
)

export default component.exports